import { useReport } from './hooks/use-context';

export function InitialInfos() {
  const { header, values } = useReport();

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '13fr 12fr 5fr',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateRows: 'repeat(3, auto)',
        }}
      >
        <div
          style={{
            display: 'flex',
            padding: '4px',
            borderRight: '1px #000 solid',
            borderBottom: '1px #000 solid',
          }}
        >
          <div style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Participante:
          </div>
          <div style={{ flex: 1, textAlign: 'center', fontSize: '12px' }}>
            {values?.participante?.answers?.[0]?.content}
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            padding: '4px',
            borderRight: '1px #000 solid',
            borderBottom: '1px #000 solid',
          }}
        >
          <div style={{ fontWeight: 'bold', fontSize: '12px' }}>Local:</div>
          <div style={{ flex: 1, textAlign: 'center', fontSize: '12px' }}>
            {values?.local?.answers?.[0]?.content}
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            padding: '4px',
            borderRight: '1px #000 solid',
            borderBottom: '1px #000 solid',
          }}
        >
          <div style={{ fontWeight: 'bold', fontSize: '12px' }}>Área:</div>
          <div style={{ flex: 1, textAlign: 'center', fontSize: '12px' }}>
            {values?.area?.answers?.[0]?.content}
          </div>
        </div>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateRows: 'repeat(3, auto)',
        }}
      >
        <div
          style={{
            display: 'flex',
            padding: '4px',
            borderRight: '1px #000 solid',
            borderBottom: '1px #000 solid',
          }}
        >
          <div style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Data Inspeção:
          </div>
          <div style={{ flex: 1, textAlign: 'center', fontSize: '12px' }}>
            {header?.event_created_at}
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            padding: '4px',
            borderRight: '1px #000 solid',
            borderBottom: '1px #000 solid',
          }}
        >
          <div style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Tipo de Inspeção:
          </div>
          <div style={{ flex: 1, textAlign: 'center', fontSize: '12px' }}>
            {`(${
              values?.tipo_inspecao?.answers?.[0]?.option === 'IG' ? 'x' : ' '
            }) IG  (${
              values?.tipo_inspecao?.answers?.[0]?.option === 'ST' ? 'x' : ' '
            }) ST  (${
              values?.tipo_inspecao?.answers?.[0]?.option === 'GE' ? 'x' : ' '
            }) GE  (${
              values?.tipo_inspecao?.answers?.[0]?.option === 'RE' ? 'x' : ' '
            }) RE`}
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            padding: '4px',
            borderRight: '1px #000 solid',
            borderBottom: '1px #000 solid',
          }}
        >
          <div style={{ fontWeight: 'bold', fontSize: '12px' }}>
            Responsável da Área:
          </div>
          <div style={{ flex: 1, textAlign: 'center', fontSize: '12px' }}>
            {values?.responsavel_area?.answers?.[0]?.content}
          </div>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          fontWeight: 'bold',
          alignItems: 'center',
          borderBottom: '1px #000 solid',
          fontSize: '12px',
        }}
      >
        % Conformidade
      </div>
    </div>
  );
}
